






































































































































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import apiUser from '@/api/user'
import { toSubArray } from '@/utils/groupBy'
import { directPayloadQuery } from '@/utils/api' 
import { AloSejour, getDefaultAloSejour } from '@/models/alo/AloSejour'
import cloneDeep from 'clone-deep'
import * as rules from '@/utils/validationRules'
import { ApiUserRole } from '@/enum/ApiUserRole'
import mailTemplate from '@/api/mailTemplate'
import { TemplateMail } from '@/enum/TemplateMail'
import { AloUser, getDefaultAloUser } from '@/models/alo/AloUser'
import { VuetifyConfirmObject } from 'vuetify-confirm'


@Component({
  name: 'FormSejour', 
  props: {
    sejourId:Number,
    useUser:{
      type:Boolean,
      default:false
    }
  },
  components: {},
})

export default class FormSejour extends Vue {
  sejourId!: number
  private showError = false    
  private rightDrawer = false
  private loading = false
  private saving = false
  private origine!:string
  private useUser!:boolean

  private showCheckOut = false
  private showCheckIn = false

  private original:AloSejour = getDefaultAloSejour(ApiUserRole.Client)
  private sejour:AloSejour = getDefaultAloSejour(ApiUserRole.Client) 

  get isVisiteur() {
    return this.$store.myGetters.isVisiteur
  }

  get isCentralWeb() {
    return this.$store.myGetters.isCentralWeb
  } 

  get sjrCheckOut(){
    //@ts-ignore
    return this.$options.filters.formatDate(this.sejour.sjrCheckOut,"YYYY-MM-DD");
  }
  set sjrCheckOut(value:string){
    this.sejour.sjrCheckOut = value
  }

  get sjrCheckIn(){
    //@ts-ignore
    return this.$options.filters.formatDate(this.sejour.sjrCheckIn,"YYYY-MM-DD");
  }
  set sjrCheckIn(value:string){
    this.sejour.sjrCheckIn = value
  }

  get canReception() {
    return this.$store.myGetters.canReception
  }           
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  loadSejour() {            
    if(this.sejourId != -1){
      this.loading = true    
      this.$store.myActions.ADM_SEJOUR_DETAIL_REQUEST(this.sejourId).then((item:AloSejour)=> {
        this.original = {...getDefaultAloSejour(ApiUserRole.Client,this.$route?.query?.num as string??""),...item}    
        this.sejour = cloneDeep(this.original)
      })
      .finally(() => {      
        this.loading = false        
      })    
    }
    else{
      
      this.original = getDefaultAloSejour(ApiUserRole.Client,this.$route?.query?.num as string??"")
      if(this.useUser) this.original.user = this.$store.myGetters.user
      this.sejour =  {...getDefaultAloSejour(ApiUserRole.Client,this.$route?.query?.num as string??""),user:this.original!.user}
    }
  }

  created(){    
    this.loadSejour()    
  }  

  deleteSejour(){
    //@ts-ignore
    this.$confirm(`${this.$t('Reception.AlertDelete')} "${this.sejour.user.libelle}" ?`,{title: this.$t('Global.Warning')} as VuetifyConfirmObject).then((answer) => {
      if (answer) {          
        this.$store.myActions.ADM_SEJOUR_DELETE_REQUEST(this.sejour.id).then(()=>{
          this.$router.push({name:"Sejour"})
        })        
      } 
    })    
  }

  addChambre() {
    this.sejour.chambres.push("")
  }

  ruleRequired(v:string) {
    return rules.ruleRequired(v)
  }    

  saveSejour(autoRedirect=true) {  
    if ((this.$refs.editForm as HTMLFormElement).validate()) {  
      this.saving = true
      return this.$store.myActions.ADM_SEJOUR_SAVE_REQUEST(this.sejour).then(()=>{          
        if(autoRedirect) this.$router.push({name:"Sejour"})
      }).finally(()=>{
        this.saving = false
      })
    }
  }

  sendEmail(){
    //si on est de la reception on valide à la sauvegarde
    if(this.canReception){
      this.sejour.sjrEnable = true
      this.sejour.mtpId = TemplateMail.SejourAcces
      this.saveSejour()
    }    
  }

  createAccess() {    
    this.sejour.mtpId = TemplateMail.SejourAjoute    
    this.saveSejour(false)?.then((sejour)=>{
      this.$confirm(this.$t('Reception.AlertCreate').toString(),{title: this.$t('Reception.AlertCreateTitle'),buttonTrueText:this.$t('Global.Ok'),buttonFalseText:""} as VuetifyConfirmObject)
      this.$store.myActions.AUTH_USER_REQUEST().then(()=>{
        this.$router.push({name:'Home'})
      })
    })
  }

}
